import type { Props as BlogPostProps } from '@99designs/acquisition-frontend/shared/components/BlogPost/BlogPost';
import type { ProductLandingGroupKey } from '../../lib/productLandingGroups';
import type { HowItWorksProps } from './HowItWorksSection/HowItWorksSection';

export interface CategoryHeroConfig {
    titlePrefix: string;
    title: string;
    description: string;
    headingGradient: string[];
    interaction?: InteractionProps;
    images: Image[];
}

export interface InteractionProps {
    link: string;
    buttonColor: string;
    buttonText: string;
}

export type Image = {
    src: string;
    designer: string;
    title: string;
};

export type CategoryConfig = {
    key: ProductLandingGroupKey;
    title: string;
    pageTitle: string;
    description: string;
    productName: string;
    productSchema: ProductSchema;
    hero?: CategoryHeroConfig;
    howItWorks?: HowItWorksProps;
    bundleFeatureComparison?: BundleFeatureComparisonConfig;
    faq: FAQ;
    blogPosts: BlogPostProps[];
};

interface ProductSchema {
    name: string;
    description: string;
    ratingValue: string;
    reviewCount: number;
}

interface FAQ {
    description: string;
}

interface BundleFeatureComparisonConfig {
    title: string;
    description: string;
    bundleIds: string[];
}

interface CategoryConfigProviderProps {
    categoryKey: string;
    language: string;
    render(category: CategoryConfig): JSX.Element;
}

export default function CategoryConfigProvider({
    render,
    categoryKey,
    language,
}: CategoryConfigProviderProps) {
    // TODO: Consolidate CategoryConfigProvider and the productLandingGroup definitions
    // We can use the existing logo-design json translations as a start,
    // but move data for new sections into the ProductGroup type
    // https://github.com/99designs/frontend/blob/f2b979b4d92d9f5df0eaf8d58f4a83d1d1b5d9db/libs/feature-product-landing/src/lib/productLandingGroups.tsx#L10-L13
    const categoryConfig = require(`../../../categories/logo-design.${language}.json`);
    categoryConfig.key = categoryKey;
    return render(categoryConfig);
}
